import React from "react";
import logo from "../../Assets/Images/RfLogo.svg";
import "./AuthLayout.scss";
import UseInnerWidth from "hooks/UseInnerWidth";
import { motion, AnimatePresence } from "framer-motion";
import bgRegister from "../../Assets/Images/bgIm.png";

function AuthLayout({ children }) {
  const width = UseInnerWidth();

  return (
    <AnimatePresence>
      <div className={`flex flex-row w-full h-[100vh]`}>
        <div className="flex-1 w-full pt-16">
          <div className="flex justify-center items-center">
            <div className="w-full  max-w-[30rem]">
              <img alt="logo" src={logo} className="w-[10rem]" />
            </div>
          </div>
          {children}
        </div>
        {width >= 1024 && (
          <div className="w-[55%]">
            <img
              src={bgRegister}
              alt="register image"
              className="w-full h-full object-cover"
            />
          </div>
        )}
      </div>
    </AnimatePresence>
  );
}

export default AuthLayout;
